const suggestions = (function () {
    let debounceTimer;
    $('#desktop-search__input, #mobile-search__input').on('input', function() {
        console.log('Input event triggered'); // Log to check if the event is triggered
        clearTimeout(debounceTimer);
        let query = $(this).val();
        if (query.length > 1) {
            debounceTimer = setTimeout(() => {
                $.ajax({
                    url: 'https://murdoch-university.ent.australiaeast.azure.elastic-cloud.com/api/as/v1/engines/meta-engine-public/query_suggestion',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer search-1gvrkpfv9a9px3z2w14jp4k3'
                    },
                    data: JSON.stringify({ query: query }),
                    success: function(data) {
                        console.log(data); // Log the entire response
                        // Adjust the following line based on the actual structure of the response
                        let suggestions = data.results.documents.map(item => `<li class="suggestion-item">${item.suggestion}</li>`).join('');
                        $('.search-suggestion').html(suggestions);

                        // Add click event listener to suggestion items
                        $('.suggestion-item').on('click', function() {
                            let selectedSuggestion = $(this).text();
                            $('#desktop-search__input, #mobile-search__input').val(selectedSuggestion);
                            // Trigger the search function here
                            performSearch(selectedSuggestion);
                        });
                    },
                    error: function(error) {
                        console.error('Error:', error); // Log any errors
                        $('.search-suggestion').html('<p>Failed to load suggestions. Please try again.</p>');
                    }
                });
            }, 300); // Adjust the debounce delay as needed
        } else {
            $('.search-suggestion').empty();
        }
    });

    function performSearch(query) {
        // Implement your search functionality here
        console.log('Performing search for:', query);
        // Example: Redirect to search results page
        window.location.href = `https://search.murdoch.edu.au/?q=${encodeURIComponent(query)}`;
    }
})();



export default suggestions;